import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const SectionHead = (props) => {
    const labelClass = [css(styles.label, props.classObject), props.noUnderline && css(styles.withNoBorder)].join(' ');
    return React.createElement("div", { className: labelClass }, props.children);
};
const styles = StyleSheet.create({
    label: {
        borderBottom: `1px solid ${Colors.Gray}`,
        fontSize: 20,
        fontWeight: 600,
        letterSpacing: 1,
        lineHeight: 1.7,
        marginBottom: 10,
        paddingBottom: 10,
        [MediaBreakPointUp.SM]: {
            fontSize: 18,
            paddingBottom: 12,
            marginBottom: 18,
        },
    },
    withNoBorder: {
        borderBottomStyle: 'none',
        fontWeight: 600,
        marginBottom: 12,
        paddingBottom: 0,
        [MediaBreakPointUp.SM]: {
            marginBottom: 10,
            paddingBottom: 0,
        },
    },
});
